import { useGetEmailHubStatus } from "./useGetEmailHubStatus";

export const useIsEmailHubStatusEnabled = () => {
  const { data } = useGetEmailHubStatus();

  return Boolean(data?.enabled);
};

export const useIsEmailHubStatusLoading = () => {
  const { isLoading } = useGetEmailHubStatus();

  return isLoading;
};
